import { isNumericString } from "./isNumericString";

export const sanitizeNumericValues = (
	raw: (string | number)[]
): string[] =>
	raw
		.map((v) => String(v).trim())
		.filter((v) => v !== "" && isNumericString(v));
